<div class="password-input-container">
  <input class="form-control" [type]="show ? 'password': 'text'" [(ngModel)]="password" (input)="onPasswordInput()"
    [ngClass]="{ 'is-invalid': isInValid}">
  <div (click)="togglePasswordVisibility()">
    <i class="fa fa-eye" aria-hidden="true" *ngIf="!show"></i>
    <i class="fa fa-eye-slash" aria-hidden="true" *ngIf="show"></i>
  </div>
</div>